import { AlenFirmwareUpdateStatus } from "src/pages/FleetManagement/AlenDeviceList/FirmwareUpdate/types";
import { makeAlenAxios } from ".";
import { AlenAccessToken } from "../authService";

export type FirmwareUpdateDetails = {
  channel: number;
  control_type: number;
  current_version: string;
  dev_type: number;
  firmware_key: string;
  last_upgrade_time: number;
  timeout: number;
  type: number;
  type_desc: "Main Module" | "MCU Module";
  upgrade_status: AlenFirmwareUpdateStatus;
};
type GetDeviceFirmwareUpdateResponse = {
  result: FirmwareUpdateDetails[];
};

const getDeviceFirmwareUpdate = async (
  alenAccess: AlenAccessToken,
  deviceId: string
) => {
  const alenAxios = makeAlenAxios(alenAccess);
  const response = await alenAxios.get<GetDeviceFirmwareUpdateResponse>(
    `${deviceId}/firmaware`
  );
  return response.data;
};

const requestFirmwareUpdate = async (
  alenAccess: AlenAccessToken,
  deviceId: string,
  channel: number
) => {
  const alenAxios = makeAlenAxios(alenAccess);
  const response = await alenAxios.post(`${deviceId}/firmware/${channel}`);
  return response.data;
};

export type FirmwareUpdateProgress = {
  progress: 0;
  upgrade_status: AlenFirmwareUpdateStatus;
}

type GetFirmwareUpdateProgressResponse = {
  result: FirmwareUpdateProgress;
};

const getFirmwareUpdateProgress = async (
  alenAccess: AlenAccessToken,
  deviceId: string,
  channel: number
) => {
  const alenAxios = makeAlenAxios(alenAccess);
  const response = await alenAxios.get<GetFirmwareUpdateProgressResponse>(
    `${deviceId}/firmware/${channel}/progress`
  );
  return response.data;
};
export {
  getDeviceFirmwareUpdate,
  requestFirmwareUpdate,
  getFirmwareUpdateProgress,
};
